import i18n from 'i18next'
// import Backend from 'i18next-http-backend'
import Backend from 'i18next-locize-backend'
// import SyncBackend from 'i18next-sync-fs-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import LastUsed from 'locize-lastused'
import { initReactI18next } from 'react-i18next'
import { I18N_LANGUAGE_STORAGE_KEY, supportedLanguages } from './constants'

const isProduction = import.meta.env.PROD
const supportedLngs = Object.keys(supportedLanguages)
const locizeOptions = {
  projectId: import.meta.env.REACT_APP_LOCIZE_PROJECTID,
  apiKey: import.meta.env.REACT_APP_LOCIZE_APIKEY,
  referenceLng: import.meta.env.REACT_APP_LOCIZE_REFLNG,
  version: import.meta.env.REACT_APP_LOCIZE_VERSION,
}

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  .use(LastUsed)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languagedetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // .use(SyncBackend)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    ns: ['common', 'pagelabels'],
    backend: locizeOptions,
    locizeLastUsed: locizeOptions,
    // Keep detector/resource loading aligned with the language switcher:
    // fr-MC / en-US / es-MX / it-IT resolve to fr / en / es / it.
    supportedLngs,
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    fallbackLng: 'en',
    // Prefer an explicit user choice (i18nextLng), otherwise follow the browser.
    // caches: [] so auto-detected browser language is NOT persisted — only the
    // language switcher writes i18nextLng on deliberate selection.
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: I18N_LANGUAGE_STORAGE_KEY,
      caches: [],
    },
    saveMissing: !isProduction,
    debug: !isProduction,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      bindI18n: 'languageChanged editorSaved',
    },
  })
  // eslint-disable-next-line
  .then(() => console.log('Lng initialization successful'))
  // eslint-disable-next-line
  .catch(err => console.error('Lng initialization failed - ', err))

export default i18n
